import { createSignal } from "solid-js";
import { setToken } from "../api/client";
import { setTokenPromptOpen } from "../store/ui";
import styles from "./TokenPrompt.module.css";

export function TokenPrompt() {
  const [value, setValue] = createSignal("");
  const [error, setError] = createSignal("");

  const submit = (e: Event) => {
    e.preventDefault();
    const v = value().trim();
    if (!v) {
      setError("Token cannot be empty");
      return;
    }
    setToken(v);
    setTokenPromptOpen(false);
    // Hard refresh so every module-level resource starts clean with the new token.
    window.location.reload();
  };

  return (
    <div class={styles.overlay}>
      <form class={styles.card} onSubmit={submit}>
        <h2 class={styles.title}>Backlog</h2>
        <p class={styles.hint}>Enter your bearer token to continue.</p>
        <input
          class={styles.input}
          type="password"
          placeholder="BACKLOG_TOKEN"
          value={value()}
          onInput={(e) => {
            setValue(e.currentTarget.value);
            if (error()) setError("");
          }}
          autofocus
        />
        {error() && <div class={styles.error}>{error()}</div>}
        <button type="submit" class={styles.button}>
          Continue
        </button>
      </form>
    </div>
  );
}
